export default {
  lineAt: '@funbyd', // Default value
  linkLine: 'https://lin.ee/Cdd1Uol', // Default value
  defaultAdminContactLineLink: 'https://lin.ee/Cdd1Uol',
  adminContactLineLink: 'https://lin.ee/Cdd1Uol',
  domains: [],
  partnerReferralHost: 'funbeyond.cc',
  isLoaded: false
}
